import React, { useEffect, useState } from 'react'
import PrivateLayout from '../../../../layouts/PrivateLayout/PrivateLayout'
import { Button } from 'flowbite-react';
import { FaArrowLeft, FaShare } from 'react-icons/fa';
import icon from '../../../../assets/recovery-convert.png';
import { numberWithCommas } from '../../../../utils/formatNumber';
import moment, { Moment } from 'moment';
import StatusView from '../../../../components/StatusView/StatusView';
import client from '../../../../api/client';
import showToast from '../../../../components/CustomToast/toastHelper';
import { Link } from 'react-router-dom';

interface TransferSummaryProps {
    transactionDetails: any
}
const TransferSummary = () => {
    const data = localStorage.getItem("payoutData")
    const payoutReference = JSON.parse(data ?? '')
    const [transaction, setTransaction] = useState<any>()
    const [transactionDetails, setTransactionDetails] = useState<any[]>([])


    const fetchPayoutsByReference = async () => {
        try {
            const apiUrl = `/subsidiary/payout/history?PayoutReference=${payoutReference}`;
            // const params = new URLSearchParams(filters).toString();
            const response = await client.get(`${apiUrl}`);
            console.log(response);

            setTransaction(response.data.data.items[0]);
            const message = response?.data?.message;

        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            await fetchPayoutsByReference()
        }
        fetchData()
    }, [])


    useEffect(() => {
        if (transaction) {
            const initialDetails = [
                { label: 'Transaction ID', value: transaction.id },
                { label: 'Batch Id', value: transaction.batchId },
                { label: 'Payout Reference', value: transaction.payoutReference },
                { label: 'Batch Reference', value: transaction.batchReference },
                { label: 'Debit Currency', value: transaction.debitCurrency },
                { label: 'Transaction Amount', value: numberWithCommas(transaction.amount) },
                { label: 'Fee', value: numberWithCommas(transaction.fee) },
                { label: 'Account Number', value: transaction.accountNumber },
                { label: 'Recipient Name', value: transaction?.recipientName ?? 'Not Available' },
                { label: 'Receiving Bank', value: transaction.bankName },
                { label: 'Transfer Type', value: transaction.transferType },
                { label: 'Date Initiated', value: (moment.utc(transaction?.dateInitiated).local() as Moment).format('DD-MMM-YYYY hh:mm:ss a') },
                { label: 'Settlement Date', value: (moment.utc(transaction?.dateSettled).local() as Moment).format('DD-MMM-YYYY hh:mm:ss a') },
                {
                    label: 'Status',
                    value: <StatusView status={transaction?.status} green="Successful" red="Failed" orange="Initiated" />,
                },
            ];
            setTransactionDetails(initialDetails);

        }


        // if (transaction.status === 'Awaiting Verification') {
        //     initialDetails.push({
        //         label: 'Action',
        //         value: <div className='underline hover:cursor-pointer' onClick={() => resendOtp(transaction.batchId)}>Click to resend Verification OTP</div>,
        //     });
        // }

    }, [transaction]);

    return (
        <PrivateLayout>
            <div className='flex justify-center'>

                <div className='my-10 mx-6 w-full lg:w-2/5 lg:shadow lg:p-6'>

                    <div>
                        <img src={icon} className="my-3" alt="icon" />
                        <div className="my-3">
                            <p className="text-xl font-bold">Transaction Details</p>
                            <p className="text-sm">Kindly find your transaction details below</p>
                        </div>
                    </div>
                    <div>
                        {transactionDetails.map((detail: any, index: number) => (
                            <div key={index}>
                                <div className="flex my-4 items-center text-xs">
                                    <p>{detail.label}</p>
                                    <p className="font-semibold ml-auto text-right">{detail.value}</p>
                                </div>
                                <hr />
                            </div>
                        ))}
                    </div>

                    <div className="flex flex-col md:flex-row gap-3 justify-center my-4 print:!hidden">
                        <Link to='/transfers'><Button className='rounded-full w-full' >
                            <div className='flex items-center gap-2'>
                                <FaArrowLeft />
                                Back to transfers
                            </div>
                        </Button></Link>
                        <Button className="rounded-full bg-custom-button-green">
                            <div className="flex items-center gap-2">
                                <FaShare />
                                <p>Download</p>
                            </div>
                        </Button>

                    </div>

                </div>
            </div>

        </PrivateLayout>
    )
}

export default TransferSummary
